import { cleanPhase1TextForArtifacts, partitionPhase1Blocks } from './phase1ContentDisplay'

export function phase1MessageModel(assistant) {
  const citations = assistant.citations ?? []
  const streaming = Boolean(assistant.demoStreamActive)
  const { artifactBlocks, otherBlocks } = partitionPhase1Blocks(assistant.blocks ?? [])
  const inlineParts = assistant.responseParts ?? []
  const hasArtifacts = artifactBlocks.length > 0
  const hasInlineAccess = inlineParts.some((part) => part?.type === 'integration_access_request')
  const hasVisibleOutput = hasArtifacts || otherBlocks.length > 0 || hasInlineAccess
  return {
    citations,
    streaming,
    artifactBlocks,
    otherBlocks,
    hasArtifacts,
    inlineParts,
    hasInlineParts: inlineParts.length > 0,
    text: cleanPhase1TextForArtifacts(assistant.text, hasVisibleOutput, !streaming),
  }
}
